const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function request(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${res.statusText}`);
  }

  return res.json();
}

export function getProducts() {
  return request("/products");
}

export function getRequests() {
  return request("/requests");
}

export function createRequest(data) {
  return request("/requests", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function deleteRequest(id) {
  return request(`/requests/${id}`, { method: "DELETE" });
}
